import type { Components } from '@mui/material'

export const MuiPopover: Components['MuiPopover'] = {
  styleOverrides: {
    paper: {
      WebkitBackdropFilter: 'var(--mui-popover-backdrop-filter, none)',
      backdropFilter: 'var(--mui-popover-backdrop-filter, none)',
    },
  },
}
